import { render, staticRenderFns } from "./purchasingInformation.vue?vue&type=template&id=e55a430e&scoped=true&"
import script from "./purchasingInformation.vue?vue&type=script&lang=js&"
export * from "./purchasingInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55a430e",
  null
  
)

export default component.exports